import { Grid } from "@mui/material";
import { TestContextDetails } from "../../../../components/test-context-details";
import type { TestContext, TestRunStep } from "../../../../types";
import { TestStepsPanel } from "../test-steps-panel";

interface DetailsTabProps {
  ctxs: TestContext[] | undefined;
  selectedCtx: TestContext | null;
  selectedCtxStep: TestRunStep | null;
  onContextSelect: (ctx: TestContext) => void;
  onContextUpdate: () => void;
  onContextDelete: (contextId: string) => void;
  onContextCreate: (context: Partial<TestContext>) => void;
  onContextDuplicate: (contextId: string) => void;
  onBulkDuplicate: (contexts: TestContext[]) => Promise<void>;
  onBulkDelete: (contexts: TestContext[]) => Promise<void>;
  onBulkToggleDisable: (contexts: TestContext[]) => Promise<void>;
  onContextMove: (contextId: string, newOrder: number) => void;
  onContextToggleDisable: (contextId: string) => void;
  isCreating: boolean;
  isMoving: boolean;
  mutating: boolean;
  getStepInfo: (ctx: TestContext) => TestRunStep | null;
}

export function DetailsTab({
  ctxs,
  selectedCtx,
  selectedCtxStep,
  onContextSelect,
  onContextUpdate,
  onContextDelete,
  onContextCreate,
  onContextDuplicate,
  onBulkDuplicate,
  onBulkDelete,
  onBulkToggleDisable,
  onContextMove,
  onContextToggleDisable,
  isCreating,
  isMoving,
  mutating,
  getStepInfo,
}: DetailsTabProps) {
  return (
    <Grid container spacing={{ xs: 2 }}>
      <Grid
        size={{ xs: 4, md: 3 }}
        sx={{
          overflowY: "auto",
          height: "calc(100vh - 310px)",
        }}
      >
        <TestStepsPanel
          ctxs={ctxs}
          selectedCtx={selectedCtx}
          onContextSelect={onContextSelect}
          onContextCreate={onContextCreate}
          onContextMove={onContextMove}
          onContextDelete={onContextDelete}
          onContextDuplicate={onContextDuplicate}
          onBulkDuplicate={onBulkDuplicate}
          onBulkDelete={onBulkDelete}
          onBulkToggleDisable={onBulkToggleDisable}
          onContextToggleDisable={onContextToggleDisable}
          isCreating={isCreating}
          isMoving={isMoving}
          mutating={mutating}
          getStepInfo={getStepInfo}
        />
      </Grid>
      <Grid size={{ xs: 8, md: 9 }}>
        {selectedCtx && (
          <TestContextDetails
            testContext={selectedCtx}
            testContextStep={selectedCtxStep}
            allContexts={ctxs}
            onUpdate={onContextUpdate}
          />
        )}
      </Grid>
    </Grid>
  );
}
